export default {"src":"/_next/static/media/hodl.4ce23e64.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};